import writeContainerStylesToCss from './css/writeContainerStylesToCss';
import useLiveUpdateCss from './useLiveUpdateCss';
import updateBackgroundDom from './updateBackgroundDom';
export default function ContainerStyleRenderer({
  container,
  breakpointMediaQueries
}) {
  const {
    styles,
    layout
  } = container.getValue();
  const css = writeContainerStylesToCss(container.getId(), layout.layout, styles.breakpointStyles, breakpointMediaQueries);
  useLiveUpdateCss(css, breakpointMediaQueries);
  updateBackgroundDom(container, breakpointMediaQueries);
  return null;
}